import * as React from 'react'

import { cn } from '~/styled'

type TreeListItemProps = React.ComponentProps<'li'>

export const TreeListItem = React.forwardRef<HTMLLIElement, TreeListItemProps>(
  ({ className, ...props }, ref) => (
    <li
      {...props}
      ref={ref}
      role="treeitem"
      className={cn(
        'flex',
        'items-center',
        'gap-2',
        'not-first:mt-0.5',
        className
      )}
    />
  )
)
